module.exports = "/images/left-menu-bg.png?dbd7362c8d7986b9f9cf38eb93afad7f";